// A freshness window describes the age of the local copy, not a server revision.
export const DATA_FRESHNESS_MS = 60_000;
